import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setFilter } from "../../redux/slice/Slice";


function Featured({ data }) {
    const [shuffledData, setShuffledData] = useState([]);
    const navigate = useNavigate();
const dispatch = useDispatch();
    useEffect(() => {
        if (data) {
            // Fisher-Yates shuffle algorithm
            const shuffled = [...data];
            for (let i = shuffled.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
            }
            setShuffledData(shuffled);
        }
    }, [data]);
    return (
        <div className="bg-[#e1e6eb5c] py-1 my-5">
            <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mt-[50px]">
                <div className=" border-b border-[#D9D9D9] w-full pb-[16px]">
                    <h1 className="2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl text-neutral-800 font-bold ">
                        Featured Franchise <span className="text-secondaryColor">Companies </span>
                    </h1>
                </div>
                <div className="mt-[30px] pb-[40px] grid 2xl:grid-cols-7 xl:grid-cols-7 lg:grid-cols-6 md:grid-cols-5 grid-cols-3 2xl:gap-0 xl:gap-0 lg:gap-0 md:gap-0 gap-3">
                    {shuffledData?.slice(0, 25).map((item) => (
                        <div class="relative max-w-[200px] border border-[#00000045] overflow-hidden transition-all duration-300 ease-in-out card-wrapper bg-white rounded-[5px] text-center p-[5px] flex items-center cursor-pointer" onClick={() => {
                            navigate(`/franchise-opportunity/best-businessdetails`, { state: { item: item, data: data } });
                            dispatch(setFilter(data))
                        }}>
                            <div class="relative max-w-[250px] w-full h-full card-top flex items-center min-h-[85px]">
                                <img className="min-w-[95px] max-w-[95px] mx-auto" src={`${item?.upload_logo}`} alt={`${item?.brand_name} logo`}></img>
                            </div>
                            <div class="absolute top-1/2 left-0 w-full bg-[#000000b5] p-2 text-white transform translate-y-[-50%] translate-x-full transition-all text-center duration-800 ease card-bottom h-[100%]">
                                <span class="block text-2xl font-bold tracking-wide leading-10 overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[110px] text-center mx-auto text-[16px]">{item?.brand_name}</span>
                                <span class="block text-sm mt-2">{item?.investment}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
}

export default Featured;
